<app-alert></app-alert>

<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Deposit</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/depositorList"> -->
        <button  (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button">
        <span>
          <i class="fa fa-save"></i>&nbsp;Generate Output</span>
      </button>
</span>
  </div>

  <div class="row">
    <div class="col-lg-12" id="directorTabContainer">
      <ul class="nav nav-tabs" role="tablist" style="width: auto">
        <li class="nav-item" style="width: auto">
          <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#DepositorTab"
            role="tab" [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
            Depositor Details
          </a>
        </li>
        <li class="nav-item" *ngIf="restrictTabflag" style="width: auto">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#RegulatoryTab" role="tab"
          [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
            Regulatory Information</a>
        </li>
        <li class="nav-item" *ngIf="restrictTabflag" style="width: auto">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#DepositTab" role="tab"
          [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
            Deposit details
          </a>
        </li>
      </ul>


      <div class="tab-content">

        <div class="tab-pane" id="DepositTab" role="tabcard">
          <section class="card">
            <div class="card-header">
              <span class="cat__core__title">
                <strong id="pageTitle">Deposit details</strong>
              </span>
              <span>
                <span style="float: right"  id="detailsOfDeposit">
      
                  <button class="btn btn-sm btn-primary pull-right" type="button" 
                  (click)="addNewFieldsModal()" [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
                 
                    <i class="fa fa-plus"></i>&nbsp;Add</button>
                </span>
              </span>
            </div>

              <!-- Date Filter  -->
  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span> </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
           
          

            <div class="col-md-3">
              <!-- <label>Date of Deposit is repayable</label> -->
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
                From :&nbsp;
                <input id="dateOfRepayable" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfRepayable" ngbDatepicker
                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfRepayable">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              
              </div>
            </div>

            <div class="col-md-3">
              <!-- <label>Date of Deposit</label> -->
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
              
                 To :&nbsp;
                <input id="dateOfDepositTo" class="form-control" [minDate]="futureToDateTo"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfDepositTo" ngbDatepicker
                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfDepositTo">
              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div>

            <div class="col-md-4 col-sm-6 col-xs-12">
              <br>
              <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
              <div class="input-group">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                  (click)="clearAdvSearch()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Date filter End -->
         <!-- Table of Deposite Details -->
            <div class="card-block datatable-card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="margin-bottom-50">
                    <div class="table-responsive">
                      <table datatable [dtOptions]="dtOptionDeposit" [dtTrigger]="dtTriggerDeposit"
                        class="table table-hover compact cell-border nowrap stripe" id="depositorTable"
                        style="cursor: pointer;">
                        <thead>
                          <tr>
                           
                            <th>Date of Deposit</th>
                            
                            <th>Type of Deposit</th>
                            <th>Amount</th>
                            <th style="text-align: center;">Date of Deposit is repayable</th>

                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr *ngFor="let i of depositDetailList;">
                          
                            <td>{{i.depositDetails.dateOfDeposit  | date: 'dd-MM-yyyy'}}</td>
                            
                          
                            <td>{{i.depositDetails.typeOfDeposit}}</td>
                            <td>{{i.depositDetails.amount}}</td>
                            <td style="text-align: center;">{{i.depositDetails.depositRepayableData  | date: 'dd-MM-yyyy'}}</td>
                    
                            <td style='white-space: nowrap;'>
                                <a>
                                <button type="button" (click)="editDepositDetail(i.depositDetails._id)"
                                  class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
                                  <span class="fa fa-pencil"></span>
                                </button>
                                &nbsp;&nbsp;
                                <button type="button" class="btn-sm btn btn-danger"
                                  (click)="confirmDelete(i.depositDetails._id)" [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
                                  <span class="icmn-bin"></span>
                                </button>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
            <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
              style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete deposit details?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteDepositDetails()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>      
         
        </div>

   <!-- Regulatory Information -->
        <div class="tab-pane" id="RegulatoryTab" role="tabcard">
          <section class="card">
            <div class="card-header">
              <span class="cat__core__title">
             
                <strong id="pageTitle">Regulatory Information</strong>
              </span>
            </div>

            <div class="card-block">
              <form [formGroup]='regulatoryForm' (document:click)="a.close();b.close();c.close();dt.close();d.close();e.close()">

                <div class="row ">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of Resolution passed in General Meeting</label>

                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control"  [formControl]="regulatoryForm.controls['dateOfResolution']" [(ngModel)]="dateOfResolutionPassed"
                          placeholder="dd-mm-yyyy" style="padding:6px;z-index: 0;" 
                          name="dateOfResolutionPassed" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();b.close();c.close();dt.close();d.close();e.close()">
                      <button class="input-group-addon" (click)="a.toggle();b.close();c.close();dt.close();d.close();e.close()"
                          type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>

                    <!-- <div class="input-group">
                      <input class="form-control" [formControl]="regulatoryForm.controls['dateOfResolution']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #a="ngbDatepicker"
                        (click)="a.toggle()"
                        [(ngModel)]="dateOfResolutionPassed">
                      <button class="input-group-addon" (click)="a.toggle()"
                        type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div> -->
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Amount Approved by Members</label>
                    <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['amountApproved']" class="form-control">
                      <div
                        *ngIf="regulatoryForm.controls['amountApproved'].hasError('pattern') || regulatoryForm.controls['amountApproved'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Amount Approved by Members is invalid
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of Circular for accepting Deposits</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="regulatoryForm.controls['dateOfCircular']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #b="ngbDatepicker"
                        (click)="b.toggle();a.close();c.close();dt.close();d.close();e.close()" [(ngModel)]="dateOfCircularReg">
                      <button class="input-group-addon" (click)="b.toggle();a.close();c.close();dt.close();d.close();e.close()"
                        type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of filing resolution & Circular with ROC</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="regulatoryForm.controls['dateOfFiling']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker"
                        (click)="c.toggle();b.close();a.close();dt.close();d.close();e.close()"
                        [(ngModel)]="dateOfFilingResolution">
                      <button class="input-group-addon" (click)="c.toggle();b.close();a.close();dt.close();d.close();e.close()"
                        type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Credit Rating</label>
                    <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['credit']" class="form-control">
                      <div
                        *ngIf="regulatoryForm.controls['credit'].hasError('pattern') || regulatoryForm.controls['credit'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Credit Rating is invalid
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Name of Credit Rating Agency</label>
                    <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['nameOfCredit']" class="form-control">
                      <div
                        *ngIf="regulatoryForm.controls['nameOfCredit'].hasError('pattern') || regulatoryForm.controls['nameOfCredit'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of Credit Rating Agency is invalid
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                    <label class="form-control-label">Due Date for review next Credit Rating</label>
                    <!-- <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['dueDate']" class="form-control">
                    </div> -->
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="regulatoryForm.controls['dueDate']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #dt="ngbDatepicker"
                        (click)="dt.toggle();b.close();c.close();a.close();d.close();e.close()" [(ngModel)]="dueDateForReview">
                      <button class="input-group-addon" (click)="dt.toggle();b.close();c.close();a.close();d.close();e.close()"
                        type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>

                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Aggregate % of all deposits to Paid up Share Capital, Free
                      Reserves and Security Premium
                    </label>
                    <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['aggregate']" class="form-control">
                      <div
                        *ngIf="regulatoryForm.controls['aggregate'].hasError('pattern') || regulatoryForm.controls['aggregate'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Aggregate % of all deposits is invalid
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Aggregate % of short term deposits to Paid up Share Capital, Free
                      Reserves and Security Premium
                    </label>
                    <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['shortTermAggregate']" class="form-control">
                      <div
                        *ngIf="regulatoryForm.controls['shortTermAggregate'].hasError('pattern') || regulatoryForm.controls['shortTermAggregate'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Aggregate % of short term deposits is invalid
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of Appointment of Debenture Trustee,if applicable</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="regulatoryForm.controls['dateOfAppoint']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #d="ngbDatepicker"
                        (click)="d.toggle();b.close();c.close();dt.close();a.close();e.close()"
                        [(ngModel)]="dateOfAppointment">
                      <button class="input-group-addon" (click)="d.toggle();b.close();c.close();dt.close();a.close();e.close()"
                        type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>

                  </div>



                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Name and Address of Debenture Trustee</label>
                    <div class="form-group">
                      <input [formControl]="regulatoryForm.controls['nameAndAddress']" class="form-control">
                      <div
                        *ngIf="regulatoryForm.controls['nameAndAddress'].hasError('pattern') || regulatoryForm.controls['nameAndAddress'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name and Address of Debenture Trustee is invalid
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Date of executing Trust Deed</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="regulatoryForm.controls['dateOfExecuting']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #e="ngbDatepicker"
                        (click)="e.toggle();b.close();c.close();dt.close();d.close();a.close()"
                        [(ngModel)]="dateOfExecutingTrustDeed">
                      <button class="input-group-addon" (click)="e.toggle();b.close();c.close();dt.close();d.close();a.close()"
                        type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <!--model-->
            </div>
            <div class="card-footer">
              <!-- <form [formGroup]='regulatoryForm'> -->
              <div class="form-group" align="right">
                <button class="btn btn-sm btn-primary" *ngIf="regulatoryAddButton" (click)="saveRegulatoryDetails()"
                type="button" [disabled]="!(regulatoryForm.valid) || disabledOnClick">
                  <span>
                    <i class="fa fa-save"></i>&nbsp;Save </span>
                </button>
                <button class="btn btn-sm btn-primary" *ngIf="!regulatoryAddButton" [disabled]="!(regulatoryForm.valid) || disabledOnClick"  type="button"
                  (click)="saveRegulatoryDetails()">&nbsp;Update</button>
              </div>
              <!-- </form> -->
            </div>
          </section>
        </div>

   <!-- Depositor Details -->
        <div class="tab-pane active" id="DepositorTab" role="tabcard">
          <section class="card">
            <div class="card-header">
              <span class="cat__core__title">
                <strong id="pageTitle">Depositor Details</strong>
              </span>
            </div>

            <div class="card-block">
              <form [formGroup]='depositorForm'>

                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Deposit Receipt No. </label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.depositorRecipt">
                    <div
                      *ngIf="depositorForm.controls['depositorRecipt'].hasError('required') && depositorForm.controls['depositorRecipt'].touched"
                      class="form-control-error-custom">
                      Deposit Receipt No. is required
                    </div>
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['depositorRecipt'].hasError('pattern') || depositorForm.controls['depositorRecipt'].hasError('maxlength')">
                      Deposit Receipt No. is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Depositor Type</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <select _ngcontent-c2="" class="form-control ng-pristne ng-valid ng-touched"
                      (change)='depositorSetValue(); depositorTypeChanged();' [formControl]="depositorForm.controls['depositorType']"
                      style="padding: 6px;">
                      <option _ngcontent-c2="" value="null" [selected]="true" disabled>
                        select Type
                      </option>
                      <option _ngcontent-c2="" value="Individual">
                        Individual
                      </option>
                      <option _ngcontent-c2="" value="BodyCorporate">
                        Body Corporate
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label"> Name of the depositor </label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" maxlength="20" class="form-control"
                      [formControl]="depositorForm.controls.nameOfDepositor">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['nameOfDepositor'].hasError('required') && depositorForm.controls['nameOfDepositor'].touched">
                      Name of the depositor is required
                    </div>
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['nameOfDepositor'].hasError('pattern') || depositorForm.controls['nameOfDepositor'].hasError('maxlength')">
                      Name of the depositor is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label"> Name of joint holders, if any </label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.holdersName">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['holdersName'].hasError('pattern') || depositorForm.controls['holdersName'].hasError('maxlength')">
                      Name of joint holders is invalid
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label"> PAN </label>
                    <input type="text" maxlength="10" class="form-control upperCase" [formControl]="depositorForm.controls.panNo">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['panNo'].hasError('pattern') || depositorForm.controls['panNo'].hasError('maxlength')">
                      PAN is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label> E-mail Id </label>
                    <input type="email" class="form-control" [formControl]="depositorForm.controls.emailId">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['emailId'].hasError('pattern') && depositorForm.controls['emailId'].touched">
                      E-mail Id is invalid
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="depositorForm.controls.depositorType.value =='Individual'">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label"> Is Depositor Minor? </label>
                    <div class="form-group">
                      <div class="md-radio md-radio-inline" style="display: inline-block">
                        <input id="minorYes" type="radio" [formControl]="depositorForm.controls['isMinor']"
                          style="position:absolute" name="isMinor" value="true" class="form-check-input"
                          (click)="minorYesClick()">
                        <label for="minorYes" ng style="padding: 0 29px 0px 0px">Yes</label>
                      </div>
                      <div class="md-radio md-radio-inline" style="display: inline-block">
                        <input id="minorNo" type="radio" selected [formControl]="depositorForm.controls['isMinor']"
                          style="position:absolute" name="isMinor" value="false" class="form-check-input"
                          (click)="showminorNoClick()">
                        <label for="minorNo">No</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Address </label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.address">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['address'].hasError('required') && depositorForm.controls['address'].touched">
                      Address is required
                    </div>
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['address'].hasError('pattern') || depositorForm.controls['address'].hasError('maxlength')">
                      Address is invalid
                    </div>
                  </div>
                </div>

                <div class='row'>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="showminorYesClick">
                    <label class="form-control-label">Date of Birth of minor</label>
                    <div class="input-group">
                      <input class="form-control" [maxDate]="TodayDate" (click)="a.toggle();"
                        [formControl]="depositorForm.controls['dateOfBirth']" style="padding:6px;z-index: 0;"
                        placeholder="dd-mm-yyyy" name="birthdate" ngbDatepicker #a="ngbDatepicker"
                        [(ngModel)]="dateOfBirthOfMinor">
                      <button class="input-group-addon" (click)="a.toggle();" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="showminorYesClick">
                    <label class="form-control-label">Name of Guardian</label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls['guardian']">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['guardian'].hasError('pattern') || depositorForm.controls['guardian'].hasError('maxlength')">
                      Name of Guardian is invalid
                    </div>
                  </div>
                </div>

                <div class='row' *ngIf="depositorForm.controls.depositorType.value =='BodyCorporate'">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Regd. Address </label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" maxlength="250" class="form-control" [formControl]="depositorForm.controls.regAddress">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['regAddress'].hasError('required') && depositorForm.controls['regAddress'].touched">
                      Regd. Address is required
                    </div>
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['regAddress'].hasError('pattern') || depositorForm.controls['regAddress'].hasError('maxlength')">
                      Regd. Address is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Registration Number / CIN </label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.CIN">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['CIN'].hasError('pattern') || depositorForm.controls['CIN'].hasError('maxlength')">
                      Registration Number / CIN is invalid
                    </div>
                  </div>
                </div>

                <div class='row' *ngIf="depositorForm.controls.depositorType.value =='Individual'">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Particulars of the nominee </label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.nominee">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['nominee'].hasError('pattern') || depositorForm.controls['nominee'].hasError('maxlength')">
                      Particulars of the nominee is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Unique Identification No. </label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.identificationNo">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['identificationNo'].hasError('pattern') || depositorForm.controls['identificationNo'].hasError('maxlength')">
                      Unique Identification No. is invalid
                    </div>
                  </div>
                </div>

                <div class='row'>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Occupation </label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.occupation">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['occupation'].hasError('pattern') || depositorForm.controls['occupation'].hasError('maxlength')">
                      Occupation is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Nationality</label>
                    <!-- <input type="text" class="form-control" [formControl]="depositorForm.controls.nationality"> -->
                    <select class="form-control" [formControl]="depositorForm.controls.nationality"
                    style="padding:6px;">
                    <option value="null" [selected]="true">Select</option>
                    <option *ngFor="let country of countryList"
                      [selected]="country.Country==depositorForm.controls.nationality.value"
                      [value]="country.Country">
                      {{country.Country}}
                    </option>
                    <!-- <option value="Indian">Indian</option> -->
                  </select>
                  </div>
                </div>

                <div class='row'>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label">Mandate and instructions for payment of interest and for
                      non-deduction of tax at source, if any </label>
                    <input type="text" class="form-control" [formControl]="depositorForm.controls.paymentOfIntrest">
                    <div class="form-control-error-custom"
                      *ngIf="depositorForm.controls['paymentOfIntrest'].hasError('pattern') || depositorForm.controls['paymentOfIntrest'].hasError('maxlength')">
                      Mandate and instructions for payment of interest and for non-deduction of tax at source is invalid
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label class="form-control-label form-group">Whether the amount of deposit is given out of loan
                      taken? </label>
                    <div class="form-group">
                      <div class="md-radio md-radio-inline" style="display: inline-block">
                        <input id="loanTakenYes" type="radio" [formControl]="depositorForm.controls['loanTaken']"
                          style="position:absolute" name="loanTaken" value="true" class="form-check-input">
                        <label for="loanTakenYes" style="padding: 0 29px 0px 0px">Yes</label>
                      </div>
                      <div class="md-radio md-radio-inline" style="display: inline-block">
                        <input id="loanTakenNo" type="radio" selected
                          [formControl]="depositorForm.controls['loanTaken']" style="position:absolute" name="loanTaken"
                          value="false" class="form-check-input">
                        <label for="loanTakenNo">No</label>
                      </div>
                    </div>
                    <div
                      *ngIf="depositorForm.controls['loanTaken'].hasError('required') && depositorForm.controls['loanTaken'].touched"
                      class="form-control-error-custom">
                      Whether the amount of deposit is given out of loan taken is required
                    </div>
                  </div>
                </div>

              </form>
            </div>
            <div class="card-footer">
              <!-- <form [formGroup]='depositorForm'> -->
              <div class="form-group" align="right">
                <button class="btn btn-sm btn-primary" *ngIf="depositorAddButton" (click)="saveDepositorData('add')"
                type="button" [disabled]="!(depositorForm.valid) || disabledOnClick">
                  <span>
                    <i class="fa fa-save"></i>&nbsp;Save </span>
                </button>
                <button class="btn btn-sm btn-primary" *ngIf="!depositorAddButton" [disabled]="!(depositorForm.valid) || disabledOnClick" type="button"
                  (click)="saveDepositorData('update')">Update</button>
              </div>
              <!-- </form> -->
            </div>
          </section>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- deposit details popup -->
<div class="modal fade" id="addNewForm" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog dynamicFieldModal" role="document">
    <div class="modal-content">
      <form [formGroup]="addDepositForm">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">
          <i class="fa fa-question-circle-o mr-2"></i>Add Details of Deposit</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="resetFields()">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <button class="btn btn-success pull-right" (click)="addNewFields()" 
                class="btn btn-sm btn-primary mb-2" type="button"  *ngIf = "addDeposites" style="margin-top: -5px; margin-bottom: 15px !important; float: right"
                [appHasPermission]="{'Url': '/register/depositorList/edit?goveva=true&email=', 'method':'put', 'menu': 'depositorList'}">
                <i class="fa fa-plus"></i>&nbsp;Add</button>
              <form [formGroup]="addDepositForm" class="form-horizontal">

                <div class="col-md-12 clearfix" formArrayName="newField"
                  *ngFor="let Field of newFieldArray; let i = index;" style="overflow-x: auto; border: 1px solid #b2d0ce; margin-bottom: 20px; padding: 15px;">
                  <div [formGroupName]="i">
                    <div class="row">
                      <div class="col-md-12">
                        <table style="margin-bottom: 10px; width: auto; min-width: 100%;">
                          <tbody>
                            <!-- ALL Labels in ONE Row -->
                            <tr>
                              <td style="padding: 5px; min-width: 150px;"><label>Date of Deposit<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Amount<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Type of Deposit<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 250px;"><label>% of Deposit to Paid up Share Capital, Free Reserves and Security Premium</label></td>
                              <td style="padding: 5px; min-width: 180px;"><label>If selected Exempted Deposits specify</label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Nature of Deposit</label></td>
                              <td style="padding: 5px; min-width: 180px;"><label>Duration of the Deposit (months)<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Duration of the Deposit (Date From)</label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Duration of the Deposit (Date To)</label></td>
                              <td style="padding: 5px; min-width: 180px;"><label>Date on which Deposit is repayable<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 200px;"><label>Deposits to be payable to the Depositor<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Rate of Interest<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 180px;"><label>Due date of payment of interest<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 180px;"><label>Date on which payment of interest to be made<span style="color: red;">*</span></label></td>
                              <td style="padding: 5px; min-width: 250px;"><label>Details of Deposit insurance including extent of Deposit insurance</label></td>
                              <td style="padding: 5px; min-width: 250px;"><label>Particulars of security or charge created for repayment of Deposits</label></td>
                              <td style="padding: 5px; min-width: 150px;"><label>Reference to CHG 7, if any</label></td>
                              <td style="padding: 5px; min-width: 80px;"><label>Action</label></td>
                            </tr>
                            
                            <!-- ALL Inputs in ONE Row -->
                            <tr>
                              <td style="padding: 5px; min-width: 150px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.dateOfDeposit" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();c.close();d.close();e.close();f.close();g.close();hh.close();">
                                  <button class="input-group-addon" (click)="a.toggle();c.close();d.close();e.close();f.close();g.close();hh.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['dateOfDeposit'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['dateOfDeposit'].touched" class="form-control-error-custom">Required</div>
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <input type="text" class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls['amount']" formControlName="{{'amount'}}">
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['amount'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['amount'].touched" class="form-control-error-custom">Required</div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['amount'].hasError('pattern')|| addDepositForm.controls.newField.controls[i].controls['amount'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <select class="form-control" name="typeOfDeposit" id="typeOfDeposit" formControlName="typeOfDeposit" [formControl]="addDepositForm.controls.newField.controls[i].controls['typeOfDeposit']" [value]="addDepositForm.controls.newField.controls[i].controls['typeOfDeposit'].value" style="padding:6px;">
                                  <option value="" [selected]="true">Select Type</option>
                                  <option value="Public Deposit" [selected]="addDepositForm.controls.newField.controls[i].controls['typeOfDeposit'].value=='Public Deposit'">Public Deposit</option>
                                  <option value="Deposit From Members" [selected]="addDepositForm.controls.newField.controls[i].controls['typeOfDeposit'].value=='Deposit From Members'">Deposit from Members</option>
                                  <option value="Exempted Deposits" [selected]="addDepositForm.controls.newField.controls[i].controls['typeOfDeposit'].value=='Exempted Deposits'">Exempted Deposits</option>
                                </select>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['typeOfDeposit'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['typeOfDeposit'].touched" class="form-control-error-custom">Required</div>
                              </td>
                              <td style="padding: 5px; min-width: 250px;">
                                <input type="text" class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.percentageOfDeposit" formControlName="{{'percentageOfDeposit'}}">
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['percentageOfDeposit'].hasError('pattern')|| addDepositForm.controls.newField.controls[i].controls['percentageOfDeposit'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                              </td>
                              <td style="padding: 5px; min-width: 180px;">
                                <input type="text" class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.exemptedDeposits" formControlName="{{'exemptedDeposits'}}">
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <select class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls['natureOfDeposit']" style="padding:6px;" [value]="addDepositForm.controls.newField.controls[i].controls['natureOfDeposit'].value">
                                  <option value="" [selected]="true">Select</option>
                                  <option value="Long Term - 6months to 36months" [selected]="addDepositForm.controls.newField.controls[i].controls['natureOfDeposit'].value =='Long Term - 6months to 36months'">Long Term - 6 months to 36 months</option>
                                  <option value="Short Term - 3months to 6months" [selected]="addDepositForm.controls.newField.controls[i].controls['natureOfDeposit'].value == 'Short Term - 3months to 6months'">Short Term - 3 months to 6 months</option>
                                </select>
                              </td>
                              <td style="padding: 5px; min-width: 180px;">
                                <input type="text" class="form-control hideSpinners" id="months" formControlName="{{'months'}}" [formControl]="addDepositForm.controls.newField.controls[i].controls['months']">
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['months'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['months'].touched" class="form-control-error-custom">Required</div>
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.dateFrom" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle();a.close();d.close();e.close();f.close();g.close();hh.close();">
                                  <button class="input-group-addon" (click)="c.toggle();a.close();d.close();e.close();f.close();g.close();hh.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.dateTo" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle();a.close();c.close();e.close();f.close();g.close();hh.close();">
                                  <button class="input-group-addon" (click)="d.toggle();a.close();c.close();e.close();f.close();g.close();hh.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                              </td>
                              <td style="padding: 5px; min-width: 180px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.depositRepayableData" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #e="ngbDatepicker" (click)="e.toggle();a.close();c.close();d.close();f.close();g.close();hh.close();">
                                  <button class="input-group-addon" (click)="e.toggle();a.close();c.close();d.close();f.close();g.close();hh.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['depositRepayableData'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['depositRepayableData'].touched" class="form-control-error-custom">Required</div>
                              </td>
                              <td style="padding: 5px; min-width: 200px;">
                                <input type="text" class="form-control" id="depositsPayableToDepositor" formControlName="{{'depositsPayableToDepositor'}}" [formControl]="addDepositForm.controls.newField.controls[i].controls['depositsPayableToDepositor']">
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['depositsPayableToDepositor'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['depositsPayableToDepositor'].touched" class="form-control-error-custom">Required</div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['depositsPayableToDepositor'].hasError('pattern')|| addDepositForm.controls.newField.controls[i].controls['depositsPayableToDepositor'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <input type="text" class="form-control" id="rateOfInterest" [formControl]="addDepositForm.controls.newField.controls[i].controls['rateOfInterest']">
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['rateOfInterest'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['rateOfInterest'].touched" class="form-control-error-custom">Required</div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['rateOfInterest'].hasError('pattern')|| addDepositForm.controls.newField.controls[i].controls['rateOfInterest'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                              </td>
                              <td style="padding: 5px; min-width: 180px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.dueDateOfPaymentOfInterest" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #f="ngbDatepicker" (click)="f.toggle();a.close();c.close();d.close();e.close();g.close();hh.close();">
                                  <button class="input-group-addon" (click)="f.toggle();a.close();c.close();d.close();e.close();g.close();hh.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['dueDateOfPaymentOfInterest'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['dueDateOfPaymentOfInterest'].touched" class="form-control-error-custom">Required</div>
                              </td>
                              <td style="padding: 5px; min-width: 180px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.dateOfPaymentOfIntrest" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #g="ngbDatepicker" (click)="g.toggle();a.close();c.close();d.close();e.close();f.close();hh.close();">
                                  <button class="input-group-addon" (click)="g.toggle();a.close();c.close();d.close();e.close();f.close();hh.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['dateOfPaymentOfIntrest'].hasError('required') && addDepositForm.controls.newField.controls[i].controls['dateOfPaymentOfIntrest'].touched" class="form-control-error-custom">Required</div>
                              </td>
                              <td style="padding: 5px; min-width: 250px;">
                                <div class="input-group" (click)="$event.stopPropagation()">
                                  <input class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls.dateOfDepositInsurance" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #hh="ngbDatepicker" (click)="hh.toggle();a.close();c.close();d.close();e.close();f.close();g.close();">
                                  <button class="input-group-addon" (click)="hh.toggle();a.close();c.close();d.close();e.close();f.close();g.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                </div>
                              </td>
                              <td style="padding: 5px; min-width: 250px;">
                                <input type="text" class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls['repaymentOfDeposits']">
                                <div *ngIf="addDepositForm.controls.newField.controls[i].controls['repaymentOfDeposits'].hasError('pattern')|| addDepositForm.controls.newField.controls[i].controls['repaymentOfDeposits'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                              </td>
                              <td style="padding: 5px; min-width: 150px;">
                                <input type="text" maxlength="500" class="form-control" [formControl]="addDepositForm.controls.newField.controls[i].controls['CHG7']">
                              </td>
                              <td style='padding: 5px; min-width: 80px; text-align:center; vertical-align:middle;'>
                                <button type="button" class="btn-sm btn btn-danger" *ngIf="addDeposites" (click)="removeField(i)"><span class="icmn-bin"></span></button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary" *ngIf = "addDeposites" data-dismiss="modal" (click)="addDepositDetail()" [disabled]= "!(addDepositForm.valid) || disabledOnClick">
                      <i class="fa fa-check"></i>Save
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="!addDeposites" (click)="updateDepositDetail()" [disabled]= "!(addDepositForm.valid) || disabledOnClick">
                      <i class="fa fa-check"></i>&nbsp;Update
                    </button>

                    <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal" (click)="resetFields()"> 
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                </div>

               </form>
            </div>
          </div>
        </div>


